export default "__VITE_ASSET__DifRVmvK__"